// extracted by mini-css-extract-plugin
module.exports = {"container":"Qo29W","overlay":"_3RFoy","spinner":"_3AHil","spinnerLogo":"_3IDVX"};